import * as React from "react";
import styled from "styled-components";

const Container = styled.div`
  display: flex;
  overflow-y: scroll;
  height: 58vh;
`;
// const GridItem = styled.div`
//   display: flex;
//   align-items: stretch; /* Makes content fill the entire row height */
//   justify-content: center; /* Centers content horizontally */
//   background-color: lightgray; /* Just for visibility */
//   padding: 20px;
// `;

const ColumnFlexContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: inherit;
  margin-right: 7px;
`;

const FlexItem = styled.div`
  margin-bottom: 5px;
`;

export function CardGrid({
  items,
  numColumns = 3
}: {
  readonly items: React.ReactNode[];
  readonly numColumns?: number;
}) {
  const containerRefs = React.useRef<Array<HTMLDivElement | null>>(
    Array(numColumns).fill(null)
  );

  const [columnItems, setColumnItems] = React.useState<React.ReactNode[][]>(
    Array(numColumns).fill([])
  );
  const [_columnHeights, setColumnHeights] = React.useState<number[]>(
    Array(numColumns).fill(0)
  );

  // Function to distribute items dynamically
  React.useEffect(() => {
    const newColumnItems: React.ReactNode[][] = Array(numColumns)
      .fill(null)
      .map(() => []);

    const newColumnHeights = Array(numColumns).fill(0);

    items.forEach(item => {
      // Find the column with the smallest height
      const minIndex = newColumnHeights.indexOf(Math.min(...newColumnHeights));
      newColumnItems[minIndex].push(item);
      newColumnHeights[minIndex] += 350; // Assume each item ~300px height
    });

    setColumnItems(newColumnItems);
    setColumnHeights(newColumnHeights);
  }, [items, numColumns]);

  // Measure actual heights after rendering
  React.useLayoutEffect(() => {
    const newHeights = containerRefs.current.map(ref => ref?.clientHeight || 0);
    setColumnHeights(newHeights);
  }, [columnItems]);

  return (
    <Container>
      {columnItems.map((column, colIndex) => (
        <ColumnFlexContainer
          key={colIndex}
          ref={el => (containerRefs.current[colIndex] = el)}
        >
          {column.map((item, index) => (
            <FlexItem key={index}>{item}</FlexItem>
          ))}
        </ColumnFlexContainer>
      ))}
    </Container>
  );
}
